<div class="custom-dropdown">
    <div class="dropdown-selector" (click)="toggle()">
        <div class="dropdown-selected"><img *ngIf="selectedOption" [src]="selectedOption.image"/></div>
        <div class="dropdown-arrow"></div>
    </div>
    <div class="dropdown-options" [class.visible]="opened === true">
        <div *ngFor="let option of dropdownOptions" class="dropdown-option" [class.selected]="selectedOption === option" (click)="selectOption(option)">
            <img [src]="option.image"/>
        </div>
    </div>
</div>